import React from 'react';
import { change, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { SYNC_ATTENDANCE_FORM } from 'src/constants/FormNames';

import { InputField } from '../form';

const SyncWithAttendance = ({ pristine, onSubmit, submitting, dispatch, formValues, client }) => {
  const clearInput = () => {
    dispatch(change(SYNC_ATTENDANCE_FORM, 'api_attendance_id', ''));
    dispatch(change(SYNC_ATTENDANCE_FORM, 'api_attendance_token', ''));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    await onSubmit(formValues, client);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group col-6">
        <InputField name="api_attendance_id" placeholder="your attendance ID" label="JOBCAN attendance ID" />
      </div>
      <div className="form-group col-6">
        <InputField name="api_attendance_token" placeholder="your attendance token" label="JOBCAN attendance token" />
      </div>
      <div className="form-group col-6">
        <button onClick={clearInput} type="button" className="btn">
          Clear
        </button>
        <button onClick={handleSubmit} className="btn btn-primary" disabled={pristine || submitting}>
          Create
        </button>
      </div>
    </form>
  );
};

const mapStateToProps = state => ({
  formValues: getFormValues(SYNC_ATTENDANCE_FORM)(state)
});

export default connect(mapStateToProps)(SyncWithAttendance);
